import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    drawer: null,
    algoReadyTour: {
      isActive: false,
      steps: []
    }
  },
  mutations: {
    SET_DRAWER (state, payload) {
      state.drawer = payload
    },
    ACTIVATE_ALGO_READY_TOUR (state, steps = []) {
      state.algoReadyTour = {
        isActive: true,
        steps
      }
    },
    DEACTIVATE_ALGO_READY_TOUR (state) {
      state.algoReadyTour = {
        isActive: false,
        steps: []
      }
    }
  },
  actions: {

  },
})
